import {
  Box,
  Flex,
  Heading,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Text,
  VStack,
} from '@chakra-ui/react'
import { FC } from 'react'
import { keyframes } from '@emotion/react'
import { FiRefreshCw } from 'react-icons/fi'

export interface RenewPrescriptionLoadingModalProps {
  isOpen: boolean
  patientName?: string
}

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`

const pulse = keyframes`
  0% { box-shadow: 0 0 0 0 rgba(49, 130, 206, 0.4); }
  70% { box-shadow: 0 0 0 15px rgba(49, 130, 206, 0); }
  100% { box-shadow: 0 0 0 0 rgba(49, 130, 206, 0); }
`

export const RenewPrescriptionLoadingModal: FC<RenewPrescriptionLoadingModalProps> = ({
  isOpen,
  patientName,
}) => (
  <Modal
    isOpen={isOpen}
    onClose={() => undefined}
    isCentered
    closeOnOverlayClick={false}
    closeOnEsc={false}
    motionPreset="scale"
  >
    <ModalOverlay backdropFilter="blur(4px)" bg="blackAlpha.400" />
    <ModalContent borderRadius="2xl" mx={4} overflow="hidden" boxShadow="2xl">
      <ModalBody py={10} px={8}>
        <VStack spacing={8}>
          <Flex
            align="center"
            justify="center"
            width="80px"
            height="80px"
            borderRadius="full"
            bg="blue.50"
            color="blue.500"
            animation={`${pulse} 2s infinite`}
          >
            <Box animation={`${spin} 1.5s linear infinite`}>
              <FiRefreshCw size={32} />
            </Box>
          </Flex>
          <VStack spacing={3}>
            <Heading size="md" textAlign="center" color="gray.900">
              Renewing Prescription
            </Heading>
            <Text fontSize="sm" color="gray.500" textAlign="center" maxW="xs" lineHeight="tall">
              {patientName
                ? `Loading details for ${patientName}. You will be able to review before sending.`
                : 'Loading prescription details. You will be able to review before sending.'}
            </Text>
          </VStack>
        </VStack>
      </ModalBody>
    </ModalContent>
  </Modal>
)

export default RenewPrescriptionLoadingModal
